export const tenantsPl = {
  tenants: {
    onboarding: {
      title: 'Skonfiguruj workspace',
      subtitle: 'AI Workspace jest multi-tenant. Utwórz lub wybierz workspace, aby kontynuować.',
      createTitle: 'Utwórz workspace',
      createSubtitle: 'Workspace grupuje czaty, pamięć i integracje.',
      selectTitle: 'Wybierz workspace',
      selectSubtitle: 'Należysz do wielu workspace’ów. Wybierz jeden, aby kontynuować.',
      name: 'Nazwa workspace',
      namePlaceholder: 'Zespół Acme',
      description: 'Opis',
      descriptionPlaceholder: 'Opcjonalnie — do czego służy ten workspace?',
      createAction: 'Utwórz workspace',
      selectAction: 'Kontynuuj',
      role: 'Rola: {role}',
      created: 'Workspace gotowy',
      createFailed: 'Nie udało się utworzyć workspace',
      selectFailed: 'Nie udało się przełączyć workspace',
      loading: 'Ładowanie workspace’ów…',
    },
  },
}
